import type { Components } from "@mui/material";

export const MuiCircularProgress: Components["MuiCircularProgress"] = {
  styleOverrides: {
    circle: {
      color: "#F18221",
    },
  },
};
